import { bindValidator } from "../validators";

const form = document.querySelector<HTMLFormElement>(".meus-dados__form");

if(form) {
    const validator = bindValidator(form);
    
    form?.addEventListener('submit', (e) => {
        if(!validator.validate())
            e.preventDefault();
    })
}